export interface Detail {
  id: string;
  title: string;
  url: string;
}

export interface SideNavigation {
  id: string;
  label: string;
  pagePath: string;
  details: Detail[];
}

export interface MenuDetails {
  sideNavigation: SideNavigation[];
}

export interface AEMMenuContent {
  menu: MenuDetails;
}
